// Firebase Analytics — first-party GA4 instrumentation.
// Web config is public per https://firebase.google.com/docs/projects/api-keys
// — identifies the project, does not authenticate. Safe to commit.
import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyD31Fmq1R-NZ1z27jE_H6jp5dXGITszFD8',
  authDomain: 'jishu-22cb5.firebaseapp.com',
  projectId: 'jishu-22cb5',
  storageBucket: 'jishu-22cb5.firebasestorage.app',
  messagingSenderId: '426362155163',
  appId: '1:426362155163:web:f6c981130ac362f87f963e',
  measurementId: 'G-RJ2ENND1SR',
};

let analytics = null;

// Initialize Analytics lazily — `isSupported()` returns false in
// environments without IndexedDB / cookies (some embedded WebViews,
// certain Safari ITP modes), so guard the import.
isSupported()
  .then((ok) => {
    if (!ok) return;
    const app = initializeApp(firebaseConfig);
    analytics = getAnalytics(app);
  })
  .catch(() => {
    // Silently degrade — analytics never throws into product code.
  });

// Fire-and-forget event logger. No-ops if Analytics didn't initialize
// (adblocker, unsupported environment, network failure).
export function track(event, params) {
  if (!analytics) return;
  try {
    logEvent(analytics, event, params);
  } catch {
    // Never let analytics errors surface into product flow.
  }
}
